const Tooltip = ({ label }) => {
  return (
    <span
      className="absolute left-1/2 -translate-x-1/2 -top-8
                       bg-black text-white text-xs px-2 py-1 rounded opacity-0 
                       group-hover:opacity-100 transition pointer-events-none"
    >
      {label}
    </span>
  );
};

export default Tooltip;
